import React from "react";
import useAxios from "./useAxios";
import { registerSuccess ,loginSuccess,logoutSuccess} from "../features/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const useAuthCalls = () => {
  const { axiosPublic,axiosWithToken } = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const register = async (userInfo) => {
    try {
      const { data } = await axiosPublic.post("/users/", userInfo);
      dispatch(registerSuccess(data));
      console.log(data);
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };
  const login = async(info)=>{
    try {
      const {data}=await axiosPublic.post("/auth/login", info)
      dispatch(loginSuccess(data))
      navigate("/")      
    } catch (error) {
      console.log(error)
    }

  }
  const logOut=async()=>{
    try {
      await axiosWithToken("/auth/logout")
      navigate("/")
      dispatch(logoutSuccess())
    } catch (error) {
      
    }
    
  }
  return { register,login ,logOut};
};

export default useAuthCalls;
